<template>
<div class="chapter">
<div class="inner_page">
<h4 class="h4"><a id="page_26"></a><a id="sec11"></a>B Is for Beckett</h4>
<p class="poem">There is so little to say.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter1_f.vue?68ed9606